import Model from "./base/model";

class RouteTableRate extends Model{
  resourceName() {
    return "route_tables_rates";
  }

  fields() {
    return {
      route_table_id: "",
      rate: "",
      value: "",
      value_type: "",
      route_table: { jsonApi: "hasOne", type: "route_tables"},

    };
  }

}

export default new RouteTableRate();
